// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u4vG","tabsBox":"styles_tabsBox__3SPIk","createButton":"styles_createButton__1WVUM"};